import {Component, Injector, OnInit} from '@angular/core';
import {User} from "../../models/user";
import {UserService} from "../../services/user/user.service";
import {BaseComponent} from "../base/base.component";
import {CompanyDocument} from "../../models/CompanyDocument";
import Swal from "sweetalert2";
import {CompanyDocumentService} from "../../services/companyDocument/document.service";
import * as moment from "moment/moment";


@Component({
    selector: 'app-reserved-area',
    templateUrl: './reserved-area.component.html',
    styleUrls: ['./reserved-area.component.scss']
})
export class ReservedAreaComponent extends BaseComponent implements OnInit {
    mister: User = new User();
    editData: any = {
        documentName: '',
        description: '',
        expirationDate: '',
        hasExpiration: false,
        documentId: '',
    };
    typeOfDocument: string = '';
    expirationDate?: string;
    selectedDocumentModelUrl?: string;
    selectedDocumentDescription?: string;
    selectedDocumentHasExiration?: boolean;
    selectedDocumentHasModelDocument?: boolean;
    companyDocuments: CompanyDocument[] = [];
    userCompanyDocuments: CompanyDocument[] = [];
    file: File | null = null;
    file2: File | null = null;
    missingCompanyDocuments: CompanyDocument[] = [];
    userId: string = '';
    editableUser: any = {};
    savingProfile = false;
    uploadingDocument = false;
    dashboardRoute: string[] = ['/misters/dashboard'];

    constructor(
        injector: Injector,
        public userService: UserService,
        public companyDocumentService: CompanyDocumentService,
    ) {
        super(injector);
    }

    async ngOnInit(): Promise<void> {
        this.showSpinner();

        this.userId = localStorage.getItem('wisper_userId') ?? '';
        const userGroup = (localStorage.getItem('wisper_userGroup') ?? '').toLowerCase();
        if (userGroup === 'staff' || userGroup === 'accompagnatore') {
            this.dashboardRoute = ['/companies/dashboard'];
        }

        if (this.userId !== '') {
            this.mister = await this.userService.getUserById(this.userId);
            this.companyDocuments = await this.companyDocumentService.getUserCompanyDocuments(
                localStorage.getItem('wisper_companyId') ?? '',
                this.userId
            );
        }

        this.editableUser = {...this.mister};
        await this.loadDocuments();
        this.missingCompanyDocuments = await this.userService.checkUserMandatoryDocuments(
            this.userId,
            localStorage.getItem('wisper_companyId') ?? ''
        );

        this.hideSpinner();
    }

    async loadDocuments(): Promise<void> {
        const response = await this.userService.getUserDocuments(this.userId);
        const documents = response.data ?? [];

        if (documents.length > 0) {
            this.userCompanyDocuments = documents.map((document: CompanyDocument) => ({
                ...document,
                uploadTime: document.UserCompanyDocument?.updatedAt
                    ? this.timeDifferenceFromToday(document.UserCompanyDocument.updatedAt)
                    : '',
            }));
        } else {
            this.userCompanyDocuments = [];
        }
    }

    timeDifferenceFromToday(oldTime: string) {
        const today = moment().startOf('day');
        const uploadTime = moment(oldTime).startOf('day');
        const passedDays = today.diff(uploadTime, 'days');

        if (passedDays > 1) return `${passedDays} giorni fa`;
        if (passedDays === 1) return `${passedDays} giorno fa`;
        if (passedDays === 0) return 'oggi';
        return '';
    }

    async saveProfile() {
        if (this.savingProfile) {
            return;
        }

        this.savingProfile = true;
        this.showSpinner();

        const success = await this.userService.updateUser(this.editableUser);

        this.hideSpinner();
        this.savingProfile = false;

        if (success) {
            this.mister = {...this.editableUser};
            Swal.fire({
                icon: 'success',
                title: 'Profilo aggiornato con successo'
            });
        } else {
            Swal.fire({
                icon: 'error',
                title: 'Errore durante il salvataggio del profilo'
            });
        }
    }

    chooseDocument(event: any) {
        this.file = event.target.files[0];
    }

    chooseDocument2(event: any) {
        this.file2 = event.target.files[0];
    }

    resetUploadForm() {
        this.typeOfDocument = '';
        this.file = null;
        this.file2 = null;
        this.expirationDate = undefined;
        this.selectedDocumentModelUrl = '';
        this.selectedDocumentDescription = '';
        this.selectedDocumentHasExiration = false;
        this.selectedDocumentHasModelDocument = false;
    }

    async uploadDocument() {
        if (!this.file || this.uploadingDocument) {
            return;
        }

        const formData = new FormData();
        formData.append('file', this.file);

        if (this.file2) {
            formData.append('file2', this.file2);
        }

        this.uploadingDocument = true;
        this.showSpinner();

        const uploaded = await this.companyDocumentService.uploadUserCompanyDocument(
            formData,
            this.typeOfDocument,
            this.expirationDate,
            this.userId
        );

        this.hideSpinner();
        this.uploadingDocument = false;

        if (uploaded) {
            await Swal.fire({
                icon: 'success',
                title: 'Documento caricato con successo'
            });
            this.resetUploadForm();
            await this.loadDocuments();
            this.missingCompanyDocuments = await this.userService.checkUserMandatoryDocuments(
                this.userId,
                localStorage.getItem('wisper_companyId') ?? ''
            );
        } else {
            Swal.fire({
                icon: 'error',
                title: 'Errore nel caricamento del documento'
            });
        }
    }

    chooseModelDocument() {
        const selectedDocument = this.companyDocuments.find(doc => doc.id === this.typeOfDocument);

        this.selectedDocumentModelUrl = selectedDocument?.modelUrl ?? '';
        this.selectedDocumentDescription = selectedDocument?.description ?? '';
        this.selectedDocumentHasExiration = !!selectedDocument?.hasExpirationDate;
        this.selectedDocumentHasModelDocument = !!selectedDocument?.modelUrl;
    }

    async saveEditedDocument() {
        this.showSpinner();

        const success = await this.companyDocumentService.updateUserCompanyDocument(
            this.editData.documentId,
            this.editData.expirationDate || undefined
        );

        this.hideSpinner();

        if (success) {
            this.ngxSmartModalService.close('editDocumentModal');
            Swal.fire({
                icon: 'success',
                title: 'Documento aggiornato con successo'
            }).then(async () => {
                await this.loadDocuments();
            });
        } else {
            Swal.fire({
                icon: 'error',
                title: 'Errore nell\'aggiornamento del documento'
            });
        }
    }

    editDocument(userDocument: any) {
        this.editData = {
            documentName: userDocument.name,
            description: userDocument.description,
            expirationDate: userDocument.UserCompanyDocument?.expirationDate
                ? moment(userDocument.UserCompanyDocument.expirationDate).format('YYYY-MM-DD')
                : '',
            hasExpiration: !!userDocument.hasExpirationDate,
            documentId: userDocument.UserCompanyDocument.id,
        };

        this.ngxSmartModalService.resetModalData('editDocumentModal');
        this.ngxSmartModalService.open('editDocumentModal');
    }

    async deleteUserDocument(documentId?: string) {
        const result = await Swal.fire({
            icon: 'warning',
            title: 'Sei sicuro di voler eliminare il documento selezionato?',
            showCancelButton: true,
            confirmButtonText: 'Sì, elimina il documento',
            cancelButtonText: 'Annulla'
        });

        if (!result.isConfirmed) {
            return;
        }

        this.showSpinner();
        const response = await this.userService.deleteUserDocuments(this.userId, documentId ?? '');
        this.hideSpinner();

        if (response?.success) {
            Swal.fire({
                icon: 'success',
                title: 'Documento eliminato con successo'
            }).then(async () => {
                await this.loadDocuments();
                this.missingCompanyDocuments = await this.userService.checkUserMandatoryDocuments(
                    this.userId,
                    localStorage.getItem('wisper_companyId') ?? ''
                );
            });
        } else {
            Swal.fire({
                icon: 'error',
                title: 'Errore nell\'eliminazione del documento'
            });
        }
    }

    downloadDocument(url?: string) {
        if (url) {
            window.open(url, '_blank');
        }
    }

    get profileInitials(): string {
        const first = (this.mister.firstName ?? '').trim().charAt(0);
        const last = (this.mister.lastName ?? '').trim().charAt(0);
        return (first + last).toUpperCase() || 'U';
    }
}
